





























import { FontAwesomeIconProps } from '@front-app/vendor/icon-definitions';
import { defineComponent, PropType } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import RadioButton from './RadioButton.vue';

export default defineComponent({
	components: { RadioButton, FontAwesomeIcon },
	props: {
		icon: {
			type: [Object, Boolean] as PropType<FontAwesomeIconProps | false>,
			default: false,
		},
	},
});
